<template>
	<JBox class="s-p-4">
		<JBox v-if="internalNode.attrsMap" class="s-mb-6">
			<JBox v-for="(value, name) in internalNode.attrsMap" :key="name" class="s-mb-6">
				<CFormInput v-model="internalNode.attrsMap[name]" :name="name" :label="name" componentName="JInputText" @blur="putNode" />
				<JFlex class="s-justify-end s-mt-1">
					<JButton variant="error-xs" @click="removeProperty(name)">Remove</JButton>
				</JFlex>
			</JBox>
		</JBox>

		<!-- Add some properties -->
		<JBox class="s-mb-6 s-p-3 s-bg-white s-rounded s-shadow">
			<JHeadline>Data Binding</JHeadline>
			<JText class="s-text-gray-600 s-text-sm s-mb-2">You can bind form components to particular data</JText>
			<JButton variant="default-sm" @click="addProperty('v-model', 'input1')">Add data binding</JButton>
		</JBox>
	</JBox>
</template>

<script>
export default {
	data() {
		return {
			internalNode: {}
		}
	},

	methods: {
		putNode() {
			this.$store.dispatch("uiEditor/putNode", this.internalNode)
		},

		// TODO: just for quick demo
		// When adding e.g. data binding, it should create a property in data not just on the component
		// Technically you can pick which property you wanna bind to
		addProperty(property, value) {
			this.$set(this.internalNode.attrsMap, property, value)
			this.putNode()
		},

		removeProperty(property) {
			this.$delete(this.internalNode.attrsMap, property)
			this.putNode()
		}
	},

	watch: {
		"$store.state.uiEditor.selectedNodeIds": {
			handler() {
				this.internalNode = this.$store.getters["uiEditor/selectedNode"]
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
